var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "w-card-content",
    {
      staticClass: "tp-root",
      style: { width: "100%" },
      attrs: { "no-padding": "" },
    },
    [
      _vm.grid
        ? _c(
            "div",
            {
              ref: "scrollEl",
              staticClass: "tp-scroll",
              on: {
                "&scroll": function ($event) {
                  return _vm.onScroll.apply(null, arguments)
                },
              },
            },
            [
              _c(
                "div",
                { staticClass: "box-wrapper" },
                [
                  _vm.canUpload ? _c("app-upload-drop-tile") : _vm._e(),
                  _vm._l(_vm.filteredPurchases, function (purchase, u) {
                    return _c("app-to-process-file", {
                      key: u,
                      staticClass: "purchase",
                      attrs: {
                        grid: "",
                        state: _vm.state,
                        "type-state": _vm.typeState,
                        purchase: purchase,
                      },
                      on: {
                        "open-all-files": function ($event) {
                          _vm.allFilesOfPurchase = purchase
                        },
                        "send-mail": function ($event) {
                          return _vm.$emit("send-mail", $event)
                        },
                        "refresh-delete": function ($event) {
                          return _vm.$emit("refresh-delete")
                        },
                        "preview-file": function ($event) {
                          return _vm.previewFile($event)
                        },
                        download: function ($event) {
                          return _vm.downloadFile($event)
                        },
                      },
                    })
                  }),
                ],
                2
              ),
              !_vm.filteredPurchases.length && !_vm.canUpload
                ? _c("div", { staticClass: "empty-state" }, [
                    _c(
                      "span",
                      { staticClass: "empty-check" },
                      [_c("w-fa", { attrs: { icon: "check" } })],
                      1
                    ),
                    _vm._v(" " + _vm._s(_vm.$ct("all-processed")) + " "),
                  ])
                : _vm._e(),
            ]
          )
        : _c(
            "w-card",
            { staticClass: "inbox-card", style: { width: "100%" } },
            [
              _c(
                "div",
                {
                  ref: "scrollEl",
                  staticClass: "tp-scroll",
                  on: {
                    "&scroll": function ($event) {
                      return _vm.onScroll.apply(null, arguments)
                    },
                  },
                },
                [
                  _c(
                    "app-custom-table",
                    { staticClass: "inbox-data-table" },
                    [
                      _c("thead", [
                        _c("tr", [
                          _c("th", { attrs: { width: "20" } }),
                          _c("th", { attrs: { width: "44" } }),
                          _c("th", [_vm._v(_vm._s(_vm.$ct("col-supplier")))]),
                          _c("th", { attrs: { width: "150" } }, [
                            _vm._v(_vm._s(_vm.$ct("col-status"))),
                          ]),
                          _c("th", { attrs: { width: "120" } }, [
                            _vm._v(_vm._s(_vm.$ct("col-invoice-date"))),
                          ]),
                          _c("th", { attrs: { width: "140" } }, [
                            _vm._v(_vm._s(_vm.$ct("col-due-date"))),
                          ]),
                          _c(
                            "th",
                            {
                              staticClass: "amount-head",
                              attrs: { width: "120" },
                            },
                            [_vm._v(_vm._s(_vm.$ct("col-amount")))]
                          ),
                          _c("th", { attrs: { width: "200" } }, [
                            _vm._v(_vm._s(_vm.$ct("col-labels"))),
                          ]),
                          _c("th", {
                            staticClass: "actions-head",
                            attrs: { width: "30" },
                          }),
                        ]),
                      ]),
                      _vm._l(_vm.dayGroups, function (group) {
                        return [
                          _c(
                            "tbody",
                            { key: group.key, staticClass: "day-group" },
                            [
                              _c("tr", [
                                _c("td", { attrs: { colspan: 9 } }, [
                                  _vm._v(
                                    _vm._s(group.label) +
                                      " · " +
                                      _vm._s(group.count)
                                  ),
                                ]),
                              ]),
                            ]
                          ),
                          _vm._l(group.purchases, function (purchase) {
                            return _c("app-to-process-file", {
                              key: group.key + "-" + purchase.ID,
                              attrs: {
                                state: _vm.state,
                                "type-state": _vm.typeState,
                                purchase: purchase,
                              },
                              on: {
                                "open-all-files": function ($event) {
                                  _vm.allFilesOfPurchase = purchase
                                },
                                "send-mail": function ($event) {
                                  return _vm.$emit("send-mail", $event)
                                },
                                "preview-file": function ($event) {
                                  return _vm.previewFile($event)
                                },
                                download: function ($event) {
                                  return _vm.downloadFile($event)
                                },
                              },
                            })
                          }),
                        ]
                      }),
                    ],
                    2
                  ),
                ],
                1
              ),
            ]
          ),
      _vm.allFilesOfPurchase
        ? _c("app-to-process-file-all-files", {
            attrs: { purchase: _vm.allFilesOfPurchase },
            on: {
              close: function ($event) {
                _vm.allFilesOfPurchase = null
              },
              "preview-file": function ($event) {
                return _vm.previewFile($event)
              },
              download: function ($event) {
                return _vm.downloadFile($event)
              },
              "send-mail": function ($event) {
                return _vm.$emit("send-mail", $event)
              },
              "open-order": function ($event) {
                _vm.toPreviewOrder = $event
              },
            },
          })
        : _vm._e(),
      _vm.toPreviewOrder
        ? _c("app-order-preview", {
            attrs: { order: _vm.toPreviewOrder },
            on: {
              close: function ($event) {
                _vm.toPreviewOrder = null
              },
            },
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }